<template>
  <div style="padding:10px;height:100%">
          <vxe-toolbar :refresh="{query: refreshList}"  custom>
            <template #buttons>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
              <el-button v-if="hasPermission('sys:dict:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmSpanceContentTable && $refs.cecUnmSpanceContentTable.getCheckboxRecords().length === 0" plain>删除</el-button>
            </template>
          </vxe-toolbar>
           <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmSpanceContentTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{}"
            :export-config="{}"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
          <!-- <vxe-column type="seq" width="40"></vxe-column> -->
          <vxe-column type="checkbox"  width="40px"></vxe-column>
            <vxe-column
              field="sort"
              align="center"
              width="50"
              title="排序">
            </vxe-column>
          <vxe-column
              field="nameCn"
              align="center"
              title="中文名称">
                  <template slot-scope="scope">
                    <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmSpanceContent:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                    <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmSpanceContent:view')"  @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link>
                    <span v-else>{{scope.row.nameCn}}</span>
                  </template>
            </vxe-column>
          <vxe-column
              field="nameEn"
              align="center"
              title="英文名称">
            </vxe-column>
          <vxe-column title="操作" width="100px" fixed="right" align="center">
                <template slot-scope="scope">
                     <el-button v-if="hasPermission('sys:dict:edit')" type="text"  size="small" @click="edit(scope.row.id)">
                       修改
                    </el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button v-if="hasPermission('sys:dict:del')" type="text" size="small" @click="del(scope.row.id)">
                      删除
                    </el-button>
                </template>
          </vxe-column>
        </vxe-table>
    <!-- 弹窗, 新增 / 修改 -->
    <CecUnmSpanceContentForm  ref="cecUnmSpanceContentForm" @refreshDataList="refreshList"></CecUnmSpanceContentForm>
  </div>
</template>

<script>
  import CecUnmSpanceContentForm from './CecUnmSpanceContentForm'
  import cecUnmSpanceContentService from '@/api/unmspace/cecUnmSpanceContentService'
  export default {
    data () {
      return {
        dataList: [],
        functionalSpaceId: '',
        loading: false,
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: true }]
        }
      }
    },
    props: ['functionalSpaceIdsStr'],
    components: {
      CecUnmSpanceContentForm
    },
    methods: {
      // 获取数据列表
      refreshList (functionalSpaceId) {
        let paramsType = typeof functionalSpaceId
        this.loading = true
        if (functionalSpaceId && paramsType === 'string') {
          this.functionalSpaceId = functionalSpaceId
        }
        cecUnmSpanceContentService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          'functionalSpaceIdsStr': this.functionalSpaceId
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 新增
      add () {
        this.dictVisible = true
        this.$nextTick(() => {
          // this.$refs.cecUnmSpanceContentForm.init('add', {dictValueId: '', dictTypeId: this.functionalSpaceId})
          this.$refs.cecUnmSpanceContentForm.init('add', '', {id: this.functionalSpaceId})
        })
      },
        // 修改
      edit (id) {
        this.dictVisible = true
        this.$nextTick(() => {
          // this.$refs.cecUnmSpanceContentForm.init('edit', {dictValueId: id, dictTypeId: this.functionalSpaceId})
          this.$refs.cecUnmSpanceContentForm.init('edit', id)
        })
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSpanceContentTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmSpanceContentService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      closeRight () {
        this.$emit('closeRight')
      }
    }
  }
</script>
